/**
 * All Permissions for Distribution Manager role
 */
export const DISTRIBUTION_MANAGER_PERMISSIONS: string[] = [
  'dashboardView',

  // 'terminalCreate',
  'terminalView',
  'terminalDetail',
  'terminalNotes',
  'terminalEdit',
  // 'terminalConfigure',
  // 'terminalRemove',
  // 'terminalAssign',

  // 'terminalBulkTemplateApply',
  // 'terminalBulkActionRestart',
  // 'terminalBulkActionPushConfig',
  // 'terminalBulkActionPullConfig',
  // 'terminalBulkActionResetConfig',
  // 'terminalBulkActionUpgradeConfig',
  // 'terminalBulkActionSetDomain',

  // 'terminalActionRestart',
  // 'terminalActionPushConfig',
  // 'terminalActionPullConfig',
  // 'terminalActionResetConfig',
  // 'terminalActionUpgradeConfig',
  // 'terminalActionTerminalType',
  // 'terminalAdvancedEdit',
  // 'terminalTransactions',

  // 'registrationCreate',
  // 'registrationView',
  // 'registrationEdit',
  // 'registrationFinalize',
  // 'registrationCancel',
  // 'registrationTRF',
  // 'registrationDeactivate',
  // 'registrationRemove',
  //
  // 'transactionView',
  //
  // 'eventView',
  //
  'deliveryCreate',
  //
  // 'assetView',
  // 'administrationView',
  //
  // 'domainView',
  // 'domainCreate',
  // 'domainEdit',
  // 'domainRemove',
  // 'domainContractTypeView',
  // 'domainContractTypeEdit',
  // 'domainTerminalTypeView',
  // 'domainTerminalTypeEdit',
  // 'domainDataView',
  // 'domainDataEdit',
  // 'domainAssetView',
  // 'domainAssetEdit',
  //
  // 'roleView',
  // 'roleCreate',
  // 'roleCreateInheritable',
  // 'roleEdit',
  // 'roleRemove',
  //
  // 'userView',
  // 'userCreate',
  // 'userEdit',
  // 'userRemove',
  // 'userPasswordRequest',
  //
  'templateView',
  // 'templateCreate',
  // 'templateEdit',
  // 'templateRemove',
  // 'templateConfigurationEdit',
  //
  // 'contractCreate',
  // 'contractView',
  // 'contractEdit',
  // 'contractRemove',
  //
  // 'taskView',
  // 'taskCreate',
  //
  // 'terminalImport',
  // 'editNotes',
]
